<template>
  <div class="register">
    <div class="container">
      <div class="content">
        <Row class="height">
           <Col class-name="height formHeight" :lg="24-colSpan" :xs="24">
            <div class="formWrap">
              <div class="inlineBlockWrap" :class="{'step2': colSpan==6}">
                <div class="inlineBlock myBar">
                  <p class="registerTitle">欢迎加入龙腾之星</p>
                  <Form ref="register" :model="info" :rules="rules" hide-required-mark class="formStyle">
                    <FormItem prop="accountType" label="用户类型">
                      <div class="accountType">
                        <span @click="changeType('DESIGNER')" class="typeItem" :class="{'typeActive selectIcon': info.accountType=='DESIGNER'}">个人</span>
                        <span @click="changeType('ORGANIZATION')" class="typeItem" :class="{'typeActive selectIcon': info.accountType=='ORGANIZATION'}">机构</span>
                      </div>
                    </FormItem>
                    <Row :gutter="16">
                      <Col :lg="12" :xs="24">
                        <FormItem prop="mobilePhone" label="手机">
                          <Input type="tel" v-model="info.mobilePhone"></Input>
                        </FormItem>
                      </Col>
                      <Col :lg="12" :xs="24">
                        <FormItem prop="captcha" label="短信验证码">
                          <Input type="text" class="msgCodeInput" v-model="info.captcha"></Input>
                          <Button shape="circle" :disabled="codeBtnText!='获取验证码'" class="defaultBtn msgCodeBtn" @click="sendMsgCode">{{codeBtnText}}</Button>
                        </FormItem>
                      </Col>
                    </Row>
                    <Row :gutter="16">
                      <Col span="12">
                        <FormItem prop="password" label="登录密码">
                          <Input type="password" v-model="info.password"></Input>
                        </FormItem>
                      </Col>
                      <Col span="12">
                        <FormItem prop="confirmPassword" label="确认密码">
                          <Input type="password" v-model="info.confirmPassword"></Input>
                        </FormItem>
                      </Col>
                    </Row>
                  </Form>
                  <Button shape="circle" long :loading="submitting" class="defaultBtn" @click="register">注册</Button>
                  <p class="center"><router-link :to="'/login?fromUrl='+this.$route.query.fromUrl" class="blackHref">已有账号，登录</router-link></p>
                  <!-- <Divider class="lightColor" size="small">合作机构账号登录</Divider> -->
                </div>
                <div class="inlineBlock myBar">
                  <p class="registerTitle">最后一步，完善基本信息完成注册</p>
                  <Form ref="basicForm" :model="basicInfo" :rules="basicRules" hide-required-mark class="formStyle">
                    <Row v-if="info.accountType=='DESIGNER'">
                      <Col span="24">
                        <FormItem prop="trueName" label="真实姓名" :rules="trueNameRule">
                          <Input type="text" placeholder="填写真实姓名，打造同行业真实人脉" v-model="basicInfo.trueName"></Input>
                        </FormItem>
                      </Col>
                      <Col span="24">
                        <FormItem prop="idNumber" label="身份证号" :rules="IDRule">
                          <Input type="text" v-model="basicInfo.idNumber"></Input>
                        </FormItem>
                      </Col>
                    </Row>
                    <Row v-if="info.accountType=='ORGANIZATION'" :gutter="16">
                      <Col span="11">
                        <FormItem prop="trueName" label="机构全称" :rules="requiredRule">
                          <Input type="text" v-model="basicInfo.trueName"></Input>
                        </FormItem>
                      </Col>
                      <Col span="11" offset="2">
                        <FormItem prop="idNumber" label="统一社会信用代码" :rules="creditCodeRule">
                          <Input type="text" v-model="basicInfo.idNumber"></Input>
                        </FormItem>
                      </Col>
                      <Col span="11">
                        <FormItem prop="contact" label="联系人" :rules="requiredRule">
                          <Input type="text" v-model="basicInfo.contact"></Input>
                        </FormItem>
                      </Col>
                      <Col span="11" offset="2">
                        <FormItem prop="contactJob" label="联系人职务" :rules="requiredRule">
                          <Input type="text" v-model="basicInfo.contactJob"></Input>
                        </FormItem>
                      </Col>
                    </Row>
                    <Row :gutter="16">
                      <Col span="24" class="ivu-form-item-required">
                        <span class="ivu-form-item-label">所在地区</span>
                      </Col>
                      <Col span="24">
                        <Col span="8">
                          <FormItem prop="locId" :label-width="0">
                            <Select 
                              v-model="basicInfo.locId" 
                              placeholder="所在地" 
                              @on-open-change="getLocList"
                              @on-change="locSelect">
                              <Option v-for="item in locList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem prop="stateId" :label-width="0">
                            <Select 
                              v-model="basicInfo.stateId" 
                              placeholder="省份/大洲" 
                              @on-open-change="getStateList"
                              @on-change="stateSelect">
                              <Option v-for="item in stateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem prop="cityId" :label-width="0">
                            <Select 
                              v-model="basicInfo.cityId" 
                              placeholder="城市/国家" 
                              @on-open-change="getCityList"
                              @on-change="citySelect">
                              <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                          </FormItem>
                        </Col>
                        <!-- <Col span="8" v-if="basicInfo.locId==0">
                          <FormItem prop="stateId" :label-width="0">
                            <Select 
                              v-model="basicInfo.stateId" 
                              placeholder="大洲" 
                              @on-open-change="getStateList"
                              @on-change="stateSelect">
                              <Option v-for="item in stateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="8" v-if="basicInfo.locId==0">
                          <FormItem prop="cityId" :label-width="0">
                            <Select 
                              v-model="basicInfo.cityId" 
                              placeholder="国家" 
                              @on-open-change="getCityList"
                              @on-change="citySelect">
                              <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                          </FormItem>
                        </Col> -->
                      </Col>
                    </Row>
                    <template v-if="info.accountType=='DESIGNER'">
                      <FormItem prop="profession" label="主职业类型（单选）">
                        <div class="accountType typeWrap">
                          <span v-for="l in professionList" 
                            :key="l.id" 
                            class="typeItem" 
                            :class="{'typeActive': basicInfo.profession==l.id}" 
                            @click="selectProfession(l)">{{l.name}}</span>
                        </div>
                      </FormItem>
                      <FormItem prop="otherProfession" label="其他职业（多选）">
                        <div class="accountType typeWrap">
                          <span v-for="l in professionList" 
                            :key="l.id" 
                            class="typeItem" 
                            :class="{'typeActive': basicInfo.otherProfession.includes(l.id), 'typeDisabled': basicInfo.profession==l.id}"
                            @click="multipleSelect(l, 'otherProfession')">{{l.name}}</span>
                        </div>
                      </FormItem>
                    </template>
                    <FormItem v-if="info.accountType=='ORGANIZATION'" prop="profession" label="机构类型（单选）">
                      <div class="accountType typeWrap">
                        <span v-for="l in professionList" 
                          :key="l.id" 
                          class="typeItem" 
                          :class="{'typeActive': basicInfo.profession==l.id}"
                          @click="selectProfession(l)">{{l.name}}</span>
                      </div>
                    </FormItem>
                    <FormItem prop="industry" label="相关专业（多选）">
                      <div class="accountType typeWrap">
                        <div class="levelWrap" v-for="(l, i) in industryList" 
                          :key="l.id">
                          <span class="levelOne">{{l.name}}</span>
                          <div class="levelTwo">
                            <span v-for="m in industryList2[i]" 
                              :key="m.id" 
                              class="typeItem" 
                              :class="{'typeActive': basicInfo.industry.includes(m.id)}"
                              @click="multipleSelect(m, 'industry')">{{m.name}}</span>
                          </div>
                        </div>
                      </div>
                    </FormItem>
                    <p class="center">
                      <Button shape="circle" :loading="submitting" class="defaultBtn halfBtn" @click="submit">完成注册</Button>
                    </p>
                    <p class="center">
                      <FormItem prop="accept">
                        <Checkbox v-model="basicInfo.accept">
                          <span>我已阅读并接受</span>
                        </Checkbox>
                        <span class="colorText" @click="showAgreement">《龙腾之星网络服务协议》</span>
                      </FormItem>
                    </p>
                  </Form>
                </div>  
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    <Modal v-model="isAgreement" fullscreen>
      <Agreement />
      <div slot="footer" class="center">
        <Button class="defaultBtn" @click="accept">我已阅读并接受</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import centerService from "@/api/center";
import Agreement from "@/components/common/Agreement.vue";

export default {
  name: "Register",
  components: {
    Agreement
  },
  data() {
    return {
      colSpan: 12,
      info: {
        accountType: "DESIGNER"
      },
      rules: {
        accountType: [
          { required: true, message: "请选择用户类型", trigger: "blur" }
        ],
        mobilePhone: [
          {
            required: true,
            pattern: /^1[3456789]\d{9}$/,
            message: "请正确输入手机号码",
            trigger: "blur"
          }
        ],
        captcha: [
          { required: true, message: "请输入短信验证码", trigger: "blur" }
        ],
        password: [
          {
            required: true,
            message: "密码需8-16位数字英文符号两种以上组合",
            // pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
            pattern: /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?![?~!=,#&@$%.+*()|{}"<>'\-:;^_`]+$)[?~!=,#&@$%.+*()|{}"<>'\-:;^_`0-9A-Za-z]{8,16}$/
          }
        ],
        confirmPassword: [
          {
            required: true,
            message: "需与登录密码相同",
            validator: (rule, value) => {
              if (!value || value != this.info.password) {
                return false;
              }
              return true;
            }
          }
        ]
      },
      submitting: false,
      codeBtnText: "获取验证码",

      basicInfo: {
        profession: null,
        otherProfession: [],
        industry: [],
        locId: null,
        stateId: null,
        cityId: null
      },
      basicRules: {
        locId: [
          {
            required: true,
            message: "请选择所在地",
            trigger: "blur,change",
            type: "number"
          }
        ],
        stateId: [
          {
            required: true,
            message: "请选择省份/大洲",
            trigger: "blur,change",
            type: "number"
          }
        ],
        cityId: [
          {
            required: true,
            message: "请选择城市/国家",
            trigger: "blur,change",
            type: "number"
          }
        ],
        profession: [
          {
            required: true,
            message: "请选择职业类型",
            validator: (rule, value) => {
              if (value == null) {
                return false;
              }
              return true;
            },
            trigger: "change"
          }
        ],
        industry: [
          {
            required: true,
            message: "请选择相关专业",
            validator: (rule, value) => {
              if (value.length == 0) {
                return false;
              }
              return true;
            },
            trigger: "change"
          }
        ],
        accept: [
          {
            required: true,
            message: "接受用户协议才能注册",
            validator: (rule, value) => {
              if (value !== true) {
                return false;
              }
              return true;
            },
            trigger: "change"
          }
        ]
      },
      requiredRule: [
        { required: true, message: "内容不能为空", trigger: "blur" }
      ],
      trueNameRule: [
        { required: true, message: "请输入真实姓名", trigger: "blur" }
      ],
      IDRule: [
        {
          required: true,
          message: "请输入合法的身份证号",
          pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
          trigger: "blur"
        }
      ],
      creditCodeRule: [
        {
          required: true,
          message: "请输入合法的统一社会信用代码",
          pattern: /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/,
          trigger: "blur"
        }
      ],
      // 国家
      locList: [],
      stateList: [],
      inStateList: [],
      outStateList: [],
      cityList: [],
      // 职业类型/机构类型
      professionList: [],
      // 相关专业第一级
      industryList: [],
      // 相关专业第二级
      industryList2: [],

      isAgreement: false
    };
  },
  mounted() {
    if (this.gIsLogin()) {
      let user = this.$store.getters.userInfo;
      if (user.userStatus == "REGISTERING") {
        this.colSpan = 6;
        this.info.accountType = user.accountType;
      } else {
        this.$router.push("/personal_info");
      }
    }
    this.getProfessionTypes();
    this.getDesignTypes();
  },
  methods: {
    // 显示用户注册协议
    showAgreement() {
      this.isAgreement = true;
    },
    // 接受用户注册协议
    accept() {
      this.basicInfo.accept = true;
      this.isAgreement = false;
    },
    // 获取相关专业类型第一级
    getDesignTypes() {
      centerService.getDesignTypes().then(async res => {
        if (res.errorNo == 0) {
          this.industryList = res.data;
          for (let i = 0, l = res.data.length; i < l; i++) {
            this.$set(
              this.industryList2,
              i,
              await this.getIndustry(res.data[i].id)
            );
          }
        }
      });
    },
    // 获取相关专业类型第二级
    getIndustry(pid) {
      return new Promise(resolve => {
        centerService
          .getDesignTypes({ "pid.eq": pid })
          .then(res => {
            if (res.errorNo == 0) {
              resolve(res.data);
            } else {
              resolve([]);
            }
          })
          .catch(() => {
            resolve([]);
          });
      });
    },
    // 获取职业类型
    getProfessionTypes() {
      centerService
        .getProfessionTypes({ "accountType.eq": this.info.accountType })
        .then(res => {
          if (res.errorNo == 0) {
            this.professionList = res.data;
          }
        });
    },
    // 选中国家
    locSelect() {
      this.stateList = [];
      this.basicInfo.stateId = "";
      this.stateSelect();
      this.$forceUpdate();
    },
    // 选中省份
    stateSelect() {
      this.cityList = [];
      this.basicInfo.cityId = "";
      this.$forceUpdate();
      // this.$refs.basicForm.validateField('stateId')
      console.log("s-" + this.basicInfo.stateId);
    },
    // 选中城市
    citySelect() {
      this.$forceUpdate();
    },
    // 获取国家列表
    getLocList(flag) {
      if (flag && this.locList.length == 0) {
        this.getLocations("loc");
      }
    },
    // 获取省份列表
    getStateList(flag) {
      if (flag) {
        this.$refs.basicForm.validateField("locId", valid => {
          if (!valid) {
            if (
              (this.basicInfo.locId == 0 && this.outStateList.length == 0) ||
              (this.basicInfo.locId == 1 && this.inStateList.length == 0)
            ) {
              this.getLocations("state");
            } else {
              this.stateList =
                this.basicInfo.locId == 0
                  ? this.outStateList
                  : this.inStateList;
            }
          }
        });
      }
    },
    // 获取城市列表
    getCityList(flag) {
      console.log("c-" + this.basicInfo.stateId);
      if (flag) {
        this.$refs.basicForm.validateField("stateId", valid => {
          if (!valid) {
            this.getLocations("city");
          }
        });
      }
    },
    // 获取位置列表
    getLocations(flag) {
      let promise;
      if (flag == "city") {
        promise = centerService.getLocations({
          "parentid.eq": this.basicInfo.stateId
        });
      } else if (flag == "state") {
        promise = centerService.getLocations({
          "parentid.eq": this.basicInfo.locId
        });
      } else {
        promise = centerService.getLocations();
      }
      promise
        .then(res => {
          if (res.errorNo == 0) {
            if (flag == "city") {
              this.cityList = res.data;
            } else if (flag == "state") {
              this.stateList = res.data;
              if (this.basicInfo.locId == 0) {
                this.outStateList = res.data;
              }
              if (this.basicInfo.locId == 1) {
                this.inStateList = res.data;
              }
            } else {
              this.locList = res.data;
            }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(() => {
          // this.$Message.error(err.message)
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 修改用户类型
    changeType(type) {
      if (type == "ORGANIZATION") {
        this.info.accountType = type;
      } else {
        this.info.accountType = type;
      }
    },
    // 注册
    register() {
      let errNum = 0;
      this.$refs.register.validateField("mobilePhone", errMsg => {
        if (errMsg) {
          this.$Message.error(errMsg);
          errNum++;
        }
      });
      if (errNum > 0) {
        return;
      }
      this.$refs.register.validateField("captcha", errMsg => {
        if (errMsg) {
          this.$Message.error(errMsg);
          errNum++;
        }
      });
      if (errNum > 0) {
        return;
      }
      this.$refs.register.validateField("password", errMsg => {
        if (errMsg) {
          this.$Message.error(errMsg);
          errNum++;
        }
      });
      if (errNum > 0) {
        return;
      }
      this.$refs.register.validateField("confirmPassword", errMsg => {
        if (errMsg) {
          this.$Message.error("两次输入密码不一致，" + errMsg);
          errNum++;
        }
      });
      if (errNum > 0) {
        return;
      }
      this.$refs.register.validate(valid => {
        if (valid) {
          this.submitting = true;
          let condition = Object.assign({}, this.info, {
            confirmPassword: null
          });
          centerService
            .register(condition)
            .then(res => {
              if (res.errorNo == 0) {
                let fromUrl = this.$route.query.fromUrl;
                if (fromUrl) {
                  if (fromUrl.indexOf("http") == -1) {
                    this.$store.commit("setToken", res.data.accessToken);
                    this.$store.commit("setUserInfo", res.data.user);
                    window.localStorage.setItem(
                      "login_time",
                      new Date().getTime()
                    );
                    this.$router.push(fromUrl);
                  } else {
                    window.location.href = fromUrl;
                  }
                } else {
                  this.colSpan = 6;
                  this.$store.commit("setToken", res.data.accessToken);
                  this.$store.commit("setUserInfo", res.data.user);
                  this.getProfessionTypes();
                }
                // window.localStorage.setItem('login_time', new Date().getTime())
              } else {
                this.$Message.error(res.errorMessage);
              }
              this.submitting = false;
            })
            .catch(err => {
              this.submitting = false;
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        } else {
          this.$Message.error("信息未正确填写完整");
        }
      });
    },
    // 获取验证码
    sendMsgCode() {
      this.$refs.register.validateField("mobilePhone", valid => {
        if (!valid) {
          let condition = {
            smsType: "REGISTER",
            mobilePhone: this.info.mobilePhone
          };
          let timer = null;
          centerService.sendCaptcha(condition).then(res => {
            if (res.errorNo == 0) {
              let time = 60,
                _this = this;
              timer = setInterval(function() {
                time--;
                _this.codeBtnText = `获取验证码${time}`;
                if (time == 0) {
                  clearInterval(timer);
                  _this.codeBtnText = "获取验证码";
                }
              }, 1000);
            } else {
              this.$Message.error(res.errorMessage);
            }
          });
          this.$once("hook:beforeDestroy", () => {
            clearInterval(timer);
            this.codeBtnText = "获取验证码";
          });
        }
      });
    },
    // 选择主职业类型/机构类型（单选）
    selectProfession(item) {
      let id = this.basicInfo.profession;
      this.basicInfo.profession = id == item.id ? null : item.id;
      if (this.info.accountType == "DESIGNER") {
        let list = this.basicInfo.otherProfession,
          i = list.indexOf(item.id);
        if (i != -1) {
          this.basicInfo.otherProfession.splice(i, 1);
        }
      }
      this.$refs.basicForm.validateField("profession");
    },
    // 选择其他职业类型/相关专业（多选）
    multipleSelect(item, key) {
      let list = this.basicInfo[key],
        i = list.indexOf(item.id);
      if (i == -1) {
        this.basicInfo[key].push(item.id);
      } else {
        this.basicInfo[key].splice(i, 1);
      }
      this.$refs.basicForm.validateField(key);
    },
    // 完成注册
    submit() {
      let errNum = 0;
      this.$refs.basicForm.validateField("trueName", errMsg => {
        if (errMsg) {
          this.$Message.error(errMsg);
          errNum++;
        }
      });
      if (errNum > 0) {
        return;
      }
      this.$refs.basicForm.validateField("idNumber", errMsg => {
        if (errMsg) {
          this.$Message.error(errMsg);
          errNum++;
        }
      });
      if (errNum > 0) {
        return;
      }
      this.$refs.basicForm.validateField("locId", errMsg => {
        if (errMsg) {
          this.$Message.error("请选择所在地");
          errNum++;
        }
      });
      if (errNum > 0) {
        return;
      }
      this.$refs.basicForm.validateField("stateId", errMsg => {
        if (errMsg) {
          if (this.basicInfo.locId == 0) {
            this.$Message.error("请选择大洲");
          } else {
            this.$Message.error("请选择省份");
          }
          errNum++;
        }
      });
      if (errNum > 0) {
        return;
      }
      this.$refs.basicForm.validateField("cityId", errMsg => {
        if (errMsg) {
          if (this.basicInfo.locId == 0) {
            this.$Message.error("请选择国家");
          } else {
            this.$Message.error("请选择城市");
          }
          errNum++;
        }
      });
      if (errNum > 0) {
        return;
      }
      this.$refs.basicForm.validateField("profession", errMsg => {
        if (errMsg) {
          this.$Message.error(errMsg);
          errNum++;
        }
      });
      if (errNum > 0) {
        return;
      }
      this.$refs.basicForm.validateField("industry", errMsg => {
        if (errMsg) {
          this.$Message.error(errMsg);
          errNum++;
        }
      });
      if (errNum > 0) {
        return;
      }
      this.$refs.basicForm.validateField("accept", errMsg => {
        if (errMsg) {
          this.$Message.error(errMsg);
          errNum++;
        }
      });
      if (errNum > 0) {
        return;
      }
      this.$refs.basicForm.validate(valid => {
        if (valid) {
          this.submitting = true;
          let userInfo = this.$store.getters.userInfo;
          let condition = Object.assign({}, this.basicInfo, {
            accountId: userInfo.accountId
          });
          condition.industry = condition.industry.join(",");
          condition.otherProfession = condition.otherProfession.join(",");
          centerService
            .registerComplete(condition)
            .then(res => {
              if (res.errorNo == 0) {
                let newUserInfo = Object.assign({}, userInfo, condition, {
                  userStatus: "NORMAL",
                  idNumberStatus: "CHECKING"
                });
                this.$store.commit("setUserInfo", newUserInfo);
                this.$Modal.success({
                  title: "恭喜您注册完成！",
                  // content: '去登录',
                  okText: "去登录",
                  onOk: () => {
                    this.$router.push("/login?fromUrl=/personal_info");
                  }
                });
              } else {
                this.$Message.error(res.errorMessage);
              }
              this.submitting = false;
            })
            .catch(err => {
              this.submitting = false;
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        } else {
          this.$Message.error("信息未正确填写完整");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.register {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: url(/img/registerBg.jpg) no-repeat center;
  background-size: cover;
  padding: 50px 0;

  .container {
    height: 100%;
  }

  .content {
    position: relative;
    border-radius: 10px;
    height: 100%;
    background: url(/img/registerBg2.jpg) no-repeat left #ffffff;
    background-size: 75% 100%;
    padding: 15px 50px;

    .height {
      height: 100%;
    }
    .bigLogo {
      position: absolute;
      top: 50%;
      left: 0;
      max-width: 80%;
    }
    .smallLogo {
      top: 0;
      left: -25px;
      transition: 1s linear;
    }
    .registerTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
    }
    .formWrap {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: #ffffff;
      box-shadow: 6px 6px 15px 3px rgba($color: #506b78, $alpha: 0.5);
      border-top: 2px solid #00b7ee;
      height: 100%;
      overflow: hidden;

      .colorText {
        color: #00b7ee;
        cursor: pointer;
        margin-left: -10px;
      }

      .inlineBlockWrap {
        height: 100%;
        width: 200%;
        white-space: nowrap;
        font-size: 0;
      }
      .step2 {
        margin-left: -100%;
        transition: 1s linear;
      }
      .inlineBlock {
        font-size: 14px;
        width: 50%;
        max-height: 100%;
        display: inline-block;
        white-space: normal;
        padding: 15px 30px 30px;
        vertical-align: top;
        overflow: auto;
      }

      .accountType {
        height: 32px;
        border: 1px solid #a0a0a0;
        border-radius: 20px;
        display: inline-block;
        width: 100%;
        position: relative;
        vertical-align: middle;
        line-height: normal;
        text-align: center;

        .typeItem {
          display: inline-block;
          width: 46%;
          cursor: pointer;
          line-height: 22px;
          margin: 4px 1%;
          border-radius: 100px;
        }
        .typeActive {
          background: #00b7ee;
          color: #ffffff;
          cursor: default;
          position: relative;
        }
        .selectIcon::after {
          font-family: Ionicons;
          content: "\f171";
          position: absolute;
          right: 5px;
          font-size: 20px;
        }
      }
      .typeWrap {
        min-height: 32px;
        height: auto;
        text-align: left;

        .typeItem {
          width: auto;
          margin: 5px;
          padding: 0 8px;
        }
        .typeDisabled {
          color: #a2a2a2;
          cursor: not-allowed;
          pointer-events: none;
        }
      }
      .levelWrap {
        position: relative;
        padding-left: 150px;
        min-height: 32px;

        .levelOne {
          position: absolute;
          left: 0;
          top: 0;
          width: 150px;
          margin: 5px;
          padding: 0 8px;
          color: #00b7ee;
        }
      }

      .msgCodeInput {
        padding-right: 110px;
      }

      .defaultBtn {
        margin: 20px 0;
      }
      .msgCodeBtn {
        text-align: center;
        position: absolute;
        right: 0;
        // top: 24px;
        width: 110px;
        padding: 0;
        margin: 0;
      }
      .halfBtn {
        width: 50%;
      }

      .blackHref {
        color: #221715;
      }
    }
  }
}
@media (max-width: 768px) {
  .register .content {
    padding: 15px;

    .logoHeight {
      height: 20%;

      .bigLogo {
        max-width: 50%;
        transform: translateY(-50%);
      }
      .smallLogo {
        top: 50%;
        left: 0;
        transition: none;
      }
    }
    .formHeight {
      height: 80%;
    }
    .formHeight .levelWrap {
      padding-left: 0;

      .levelOne {
        position: relative;
        display: block;
        width: 100%;
        margin-bottom: 0;
      }
    }
  }
}
</style>